import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngxs/store';
import { IssuerSelectors } from '../../issuer-store/issuer-selectors';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ActionsApi {
  http = inject(HttpClient);
  store = inject(Store);

  startEdit(): void {
    this.http.post<any>(`service/{pricingMode}/edit`, this.store.selectSnapshot(IssuerSelectors.getSelectedEntityId)()).subscribe();
  }

  cancelEdit(): void {
    this.http.post<any>(`service/{pricingMode}/cancelEdit`, this.store.selectSnapshot(IssuerSelectors.getSelectedEntityId)()).subscribe();
  }

  moveToDraft(): void {
    this.http.post<any>(`service/{pricingMode}/moveToDraft`, this.store.selectSnapshot(IssuerSelectors.getSelectedEntityId)()).subscribe();
  }

  moveToReview(assignedTeamId: number): Observable<any> {
    const payload = {
      assignedTeamId,
      ...this.store.selectSnapshot(IssuerSelectors.getSelectedEntityId)()
    }
    return this.http.post<any>(`service/{pricingMode}/moveToReview`, payload);
  }

  markCompleted(): void {
    this.http.post<any>(`service/{pricingMode}/markCompleted`, this.store.selectSnapshot(IssuerSelectors.getSelectedEntityId)()).subscribe();
  }
}
